/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CatalogsOrganizationCatalogIdProductsProductIdMoveProductPutRequestFromCategory
 */
export interface CatalogsOrganizationCatalogIdProductsProductIdMoveProductPutRequestFromCategory {
    /**
     * 
     * @type {string}
     * @memberof CatalogsOrganizationCatalogIdProductsProductIdMoveProductPutRequestFromCategory
     */
    id: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CatalogsOrganizationCatalogIdProductsProductIdMoveProductPutRequestFromCategory
     */
    productIds: Array<string>;
}

/**
 * Check if a given object implements the CatalogsOrganizationCatalogIdProductsProductIdMoveProductPutRequestFromCategory interface.
 */
export function instanceOfCatalogsOrganizationCatalogIdProductsProductIdMoveProductPutRequestFromCategory(value: object): value is CatalogsOrganizationCatalogIdProductsProductIdMoveProductPutRequestFromCategory {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('productIds' in value) || value['productIds'] === undefined) return false;
    return true;
}

export function CatalogsOrganizationCatalogIdProductsProductIdMoveProductPutRequestFromCategoryFromJSON(json: any): CatalogsOrganizationCatalogIdProductsProductIdMoveProductPutRequestFromCategory {
    return CatalogsOrganizationCatalogIdProductsProductIdMoveProductPutRequestFromCategoryFromJSONTyped(json, false);
}

export function CatalogsOrganizationCatalogIdProductsProductIdMoveProductPutRequestFromCategoryFromJSONTyped(json: any, ignoreDiscriminator: boolean): CatalogsOrganizationCatalogIdProductsProductIdMoveProductPutRequestFromCategory {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'productIds': json['productIds'],
    };
}

export function CatalogsOrganizationCatalogIdProductsProductIdMoveProductPutRequestFromCategoryToJSON(json: any): CatalogsOrganizationCatalogIdProductsProductIdMoveProductPutRequestFromCategory {
    return CatalogsOrganizationCatalogIdProductsProductIdMoveProductPutRequestFromCategoryToJSONTyped(json, false);
}

export function CatalogsOrganizationCatalogIdProductsProductIdMoveProductPutRequestFromCategoryToJSONTyped(value?: CatalogsOrganizationCatalogIdProductsProductIdMoveProductPutRequestFromCategory | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'productIds': value['productIds'],
    };
}

